export default __webpack_public_path__ + "static/media/models2.cdc69ace.jpg";